import Vue from 'vue';
import QuartalskalenderService from './quartalskalender.service';

const getDefaultItem = () => ({
    id: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const quartalskalender = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await QuartalskalenderService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await QuartalskalenderService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await QuartalskalenderService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await QuartalskalenderService.query(params);
            context.commit('updateList', data);
            return data;
        },
        async queryString(context) {
            const { data } = await QuartalskalenderService.get('asstring');
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await QuartalskalenderService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default quartalskalender;
